export default __webpack_public_path__ + "static/media/451.d8a76644.svg";